import type { ComponentProps } from 'react';
import { useHrefWithParams } from '@/shared/hooks/use-navigate-with-params';

interface LegalLinkProps extends Omit<ComponentProps<'a'>, 'href'> {
  to: string;
}

/**
 * Full-page legal-document link that keeps a real href (with query params).
 * Legal pages are static HTML, not SPA routes.
 */
export function LegalLink({ to, children, ...props }: LegalLinkProps) {
  const buildHref = useHrefWithParams();

  return (
    <a data-slot="legal-link" href={buildHref(to)} {...props}>
      {children}
    </a>
  );
}
